module.exports = "./img/c1917749ac1eec347fcec3ad7f0dee5f.png";